import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';

import Alert from 'UiKit/alert';

import Head from 'View/target/section/head';
import Filter from 'View/target/section/filter';
import Table from 'View/target/section/table';
import FormUpsert from 'View/target/section/form-upsert';
import TargetProvider, { useTargetState } from 'View/target/state';

import styles from './styles.module.css';

const Target = () => {
  const { t } = useTranslation('target');
  const { state } = useTargetState();

  return (
    <Box className={styles['target__container']} data-testid="target__container">
      <Head t={t} />
      <Alert {...state?.alertProps} />
      <Filter t={t} />
      <Table t={t} />
      <FormUpsert t={t} />
    </Box>
  );
};

const TargetContainer = () => <TargetProvider children={<Target />} />;

export default TargetContainer;
